<template>
  <div class="d-flex">
    <div class="d-flex-left">
      <erp-tree-status @node-click="nodeClick"></erp-tree-status>
    </div>
    <div class="d-flex-right">
      <el-tabs v-model="activeName" type="border-card">
        <el-tab-pane label="房态列表" name="roomStatus">
          <RoomStatusList v-if="activeName === 'roomStatus'" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import ErpTree from "../Common/erp-tree";
import ErpTreeStatus from "../Common/erp-tree-status";
import RoomStatusList from "./components/room-status/RoomStatusList";

export default {
  name: "RoomStatus",
  components: {
    RoomStatusList,
    ErpTreeStatus,
    ErpTree
  },
  provide() {
    return {
      mainObj: this.mainObj,
    };
  },
  data(){
    return{
      mainObj: {
        project_id:0,
        house_name:""
      },
      activeName: "roomStatus",
    }
  },
  methods: {
    nodeClick(node){
      this.mainObj.house_name=node.tree.map(ret => {
        return ret.name
      }).join('->');
      this.mainObj.project_id=node.tree[0].id;
    }
  }
}
</script>

<style lang="scss" scoped>

.d-flex {
  display: flex;
  margin: 10px;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/HouseCode/RoomStatus.vue